import './App.css';
import React, { useState, useEffect } from 'react';
import RouterMod from './RouterMod';
import { Helmet } from 'react-helmet'

function App() {
  const [cartItems, setcartItems] = useState([]);

  function handleAddProduct(product) {
    const ProductExist = cartItems.find((item) => item.id === product.id);
    if (ProductExist) {
      setcartItems(cartItems.map((item) => item.id === product.id ?
        { ...ProductExist, quantity: ProductExist.quantity + 1 } : item
      ));
    }
    else {
      setcartItems([...cartItems, { ...product, quantity: 1 }]);
    }
  }


/*   useEffect(() => {
    const handleContextmenu = e => {
      e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
      document.removeEventListener('contextmenu', handleContextmenu)
    }
  }, []) */


  return (
    <div className="App">
      <Helmet>
        <title>Starsplex - The Entertainment Verse</title>
      </Helmet>

      <RouterMod handleAddProduct={handleAddProduct} cartItems={cartItems} />
    </div>
  );
}

export default App;
